import React, { useEffect, useState } from 'react';
import { useDispatch } from 'dva';
import Header from 'components/Header';
import Footer from 'components/Footer';
import styles from './index.less';

import bgHeader from 'images/bg_header_cip.png';
import iconEnter from 'images/ico_enter_grey@2x.png';
import router from 'umi/router';

const ErrorPage = (props) => {
  const dispathch = useDispatch();
  const query = props.location.query || {};
  const { cipId, from } = query;
  const hasCipId = !!cipId; // 有了这个id不能选择机场和出发类型
  const fromSearch = from === 'search'; // 从网点查询过来的禁止选择服务机场
  const [showSelectTypeBox, setShowSelectTypeBox] = useState(false);
  const [airportInfo, setAirportInfo] = useState({});
  const [netwrokInfo, setNetworkInfo] = useState([]);
  const [networkActIdx, setNetworkActIdx] = useState(0); // 当前所选的索引，出发类型
  useEffect(() => {
    dispathch({
      type: 'cip/getCipNetworkDetail',
      payload: { ...query },
      callback: (res) => {
        setNetworkInfo(res.list || []);
        setAirportInfo(res.airport || {});
      },
    });
  }, []);
  const { name: airportName } = airportInfo;
  const selectNetWorkInfo = netwrokInfo[networkActIdx] || {};
  const {
    name,
    usedescription,
    serivce,
    fname,
    businesshours,
    terminal,
    location,
    limitsList = [],
  } = selectNetWorkInfo;

  const infoList = [
    {
      label: '航站楼',
      value: terminal ? `${terminal}航站楼` : '',
    },
    {
      label: '位置',
      value: location,
    },
    {
      label: '营业时间',
      value: businesshours,
    },
    {
      label: '通道名称',
      value: fname,
    },
    {
      label: '服务说明',
      value: serivce,
    },
    {
      label: '使用说明',
      value: usedescription,
    },
  ];
  return (
    <div className={styles.networkDetailPage}>
      <Header title={`${airportName}快速安检`} showHome={false} />
      {/* 头部 */}
      <div className={styles.header}>
        <img className={styles.bgHeader} src={bgHeader} alt="" />
      </div>
      {/* 机场出发类型 */}
      <div className={`${styles.box} ${styles.liBox}`}>
        <div className={styles.liItem}>
          <span className={styles.desc}>服务机场</span>
          <div
            className={styles.liInfo}
            onClick={() => {
              if (hasCipId || fromSearch) return;
              router.push({
                pathname: '/search',
                query: {
                  netwrokType: 'cip',
                },
              });
            }}
          >
            <span className={styles.value}>{airportName}</span>
            {!hasCipId && !fromSearch && (
              <img className={styles.iconEnter} src={iconEnter} alt="" />
            )}
          </div>
        </div>
        <div className={styles.liItem}>
          <span className={styles.desc}>出发类型</span>
          <div
            className={styles.liInfo}
            onClick={() => {
              if (hasCipId) return;
              setShowSelectTypeBox(true);
            }}
          >
            <span className={styles.value}>{name}</span>
            {!hasCipId && <img className={styles.iconEnter} src={iconEnter} alt="" />}
          </div>
        </div>
      </div>
      {/* 信息 */}

      <div className={`${styles.box} ${styles.infoBox}`}>
        {limitsList.length > 0 && (
          <div className={styles.tip}>
            {limitsList.map((item) => {
              return <div>{item.limitsValue}</div>;
            })}
            {/* {tip || '当前时间该网点未营业，请合理安排您的行程 仅限吉祥航空航班使用'} */}
          </div>
        )}
        {infoList.map((el, index) => {
          if (!el.value) return null;
          return (
            <div className={styles.infoItem} key={index}>
              <span className={styles.label}>{el.label}</span>
              <span className={styles.value}>{el.value}</span>
            </div>
          );
        })}
      </div>
      {/* 去使用的按钮 */}
      <Footer type="cip" />
      {/* 选择出发类型 */}
      {showSelectTypeBox && (
        <div className={styles.maskBox} onClick={() => setShowSelectTypeBox(false)}>
          <div
            className={styles.contentBox}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className={`${styles.li} ${styles.title}`}>选择出发类型</div>
            {netwrokInfo.map((el, idx) => (
              <div
                className={styles.li}
                key={el.airportId}
                onClick={() => {
                  setNetworkActIdx(idx);
                  setShowSelectTypeBox(false);
                }}
              >
                {el.name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ErrorPage;
